import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type PortalTopNavTab = 'dashboard' | 'patient-outcomes' | 'referrals' | 'compliance';

@Component({
  selector: 'app-portal-top-nav',
  imports: [CommonModule],
  templateUrl: './portal-top-nav.component.html',
  styleUrl: './portal-top-nav.component.css',
})
export class PortalTopNavComponent {
  @Input() active: PortalTopNavTab = 'dashboard';
  @Input() showPatientOutcomes = false;
  @Input() showReferrals = false;
  @Input() showCompliance = false;

  @Output() dashboardClick = new EventEmitter<void>();
  @Output() patientOutcomesClick = new EventEmitter<void>();
  @Output() referralsClick = new EventEmitter<void>();
  @Output() complianceClick = new EventEmitter<void>();
}
